/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_RecipientInputs */

const cs_field_recipient = /** @type {(inputs: Field_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjemce`)
};

const en_field_recipient = /** @type {(inputs: Field_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient`)
};

/**
* | output |
* | --- |
* | "Recipient" |
*
* @param {Field_RecipientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_recipient = /** @type {((inputs?: Field_RecipientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_RecipientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_recipient(inputs)
	return cs_field_recipient(inputs)
});